import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import BaseDialog from "../ui/BaseDialog";
import ActionButton from "../ui/ActionButton";

// modal to confirm allocation or decline of a request
const AllocationConfirmModal = ({
  open,
  onClose,
  onConfirm,
  type, // 'allocate' | 'decline'
  quantity,
  companyName,
  darkMode,
  isProcessing = false,
}) => {
  const { t } = useTranslation();

  const isAllocate = type === "allocate";

  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      title={isAllocate ? t("Confirm Allocation") : t("Decline Request")}
      darkMode={darkMode}
      ariaLabelledBy="allocation-confirm-modal-title"
      ariaDescribedBy="allocation-confirm-modal-description"
      actions={
        <>
          <ActionButton
            onClick={onClose}
            variant="default"
            modal
            disabled={isProcessing}
          >
            {t("Cancel")}
          </ActionButton>
          <ActionButton
            onClick={onConfirm}
            variant={isAllocate ? "secondary" : "danger"}
            modal
            loading={isProcessing}
          >
            {isAllocate ? t("Confirm Allocation") : t("Decline Request")}
          </ActionButton>
        </>
      }
    >
      {/* message */}
      <Typography
        sx={{
          fontFamily: "Poppins",
          fontSize: "1rem",
          color: darkMode ? "#e0e0e0" : "#666666",
          textAlign: "center",
        }}
      >
        {isAllocate ? (
          <>
            {t("Are you sure you want to allocate")}{" "}
            <strong>{quantity} lbs</strong> {t("to")}{" "}
            <strong>{companyName}</strong>?
          </>
        ) : (
          <>
            {t("Are you sure you want to decline the request from")}{" "}
            <strong>{companyName}</strong>? {t("This action cannot be undone.")}
          </>
        )}
      </Typography>
    </BaseDialog>
  );
};

AllocationConfirmModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  type: PropTypes.oneOf(["allocate", "decline"]).isRequired,
  quantity: PropTypes.number,
  companyName: PropTypes.string.isRequired,
  darkMode: PropTypes.bool.isRequired,
  isProcessing: PropTypes.bool,
};

export default AllocationConfirmModal;
